import { render, staticRenderFns } from "./ViewerRegDoc.vue?vue&type=template&id=9d0a3a8a"
import script from "./ViewerRegDoc.vue?vue&type=script&lang=js"
export * from "./ViewerRegDoc.vue?vue&type=script&lang=js"
import style0 from "./ViewerRegDoc.vue?vue&type=style&index=0&id=9d0a3a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports